import React  from 'react';
import T from 'i18n-react';
import { connect } from 'react-redux';
// Style
import './Transaction.css';
//Components
import ModalTransaction from "../../components/modal/ModalTransaction";
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
// Utils
import {getCorrectDefaultDateFormat, getFormattedDate} from "../../utils/DateUtils";
//Services
import TransactionService from "../../services/TransactionService";
import { makeCancelable } from "../../utils/PromiseUtils";
import ColorEnum from "../../enums/ColorEnum";
import Loader from "react-loader";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import RaisedButton from "material-ui/RaisedButton";
import DatePicker from "material-ui/DatePicker";
import TimePicker from "material-ui/TimePicker";
import MaterialFormInput from "../../components/materialFormInput/MaterialFormInput";
import FontIcon from "material-ui/FontIcon";
import SortComponent from "../../components/sort/SortComponent";
import Pagination from "../../components/pagination/Pagination";
import Collapsible from "react-collapsible";
// Store
import { setFilterBUAction,setFilterClientAction,setFilterShopAction, setFilterLocationAction, setStartDateAction, setEndDateAction, setStartSettDateAction, setEndSettDateAction } from '../../store/filters/FilterActions';
import CheckBoxIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import IconButton from "material-ui/IconButton";
import { Card, CardText, CardTitle, Popover } from "material-ui";

/*************************************************
 * ************* Mapping du store ****************
 *************************************************/

const mapStateToProps = (state) => ({
    userData: state.userState.userData,
    initFilters: state.filterState
});

const mapDispatchToProps = (dispatch) => ({
    /**
     * Met dans le store les informations récupéré du Country
     * @param country
     */
    setFilterLocation: (country) => dispatch(setFilterLocationAction(country)),
    /**
     * Met dans le store les informations récupéré du client
     * @param client
     */
     setFilterClient: (client) => dispatch(setFilterClientAction(client)),
    /**
     * Met dans le store les informations récupéré du bu
     * @param bu
     */
     setFilterBU: (bu) => dispatch(setFilterBUAction(bu)),
    /**
     * Met dans le store les informations récupéré du shop
     * @param shop
     */
     setFilterShop: (shop) => dispatch(setFilterShopAction(shop)),
     /**
     * Met dans le store les informations récupéré du startDate
     * @param startDate
     */
     setStartDateAction: (startDate) => dispatch(setStartDateAction(startDate)),
    /**
     * Met dans le store les informations récupéré du endDate
     * @param endDate
     */
     setEndDateAction: (endDate) => dispatch(setEndDateAction(endDate)),
    /**
     * Met dans le store les informations récupéré du startSettDate
     * @param startDate
     */
    setStartSettDateAction: (startSettDate) => dispatch(setStartSettDateAction(startSettDate)),
    /**
     * Met dans le store les informations récupéré du endSettDate
     * @param endDate
     */
    setEndSettDateAction: (endSettDate) => dispatch(setEndSettDateAction(endSettDate)),
});

const inStore = "in-store";
const inStoreId = "888";
const eCommerce = "e-commerce";
const eCommerceId = "889";

class TransactionPage extends React.Component {

    constructor(props) {
        super(props);

        const todayDate = new Date();
        this.defaultStartDate = new Date(todayDate);
        this.defaultStartDate.setDate(todayDate.getDate() - 1);
        this.defaultEndDate = new Date(this.defaultStartDate);
        this.defaultStartDate.setHours(0, 0, 0, 0);
        this.defaultEndDate.setHours(23, 59, 0, 0);
        this.headerList = [];
        this.createHeaderItems();

        this.state = {
            transactionList: [],
            amountTotal: 0,
            totalRowNumber: 0,
            numberOfRowsPerPage: 20,
            page: 1,
            error: null,
            isLoading: false,
            exportLoading: false,
            selectedTransaction: null,
            detailModalOpen: false,
            popoverOpen: false,
            filterList: {
                country: props.initFilters.location ? props.initFilters.location : [],
                company: props.initFilters.selectedClient ? props.initFilters.selectedClient.map(client => client.name) : [],
                society: props.initFilters.selectedBu ? props.initFilters.selectedBu.map(bu => bu.name) : [],
                store: props.initFilters.selectedShop ? props.initFilters.selectedShop.map(shop => shop.name) : [],
                activity: null,
                idTransaction: null,
                idOrder: null,
                paymentMode: null,
                paymentType: null,
                cardCategory: null,
                cardType: null,
                startDate: props.initFilters.startDate ? getCorrectDefaultDateFormat(props.initFilters.startDate) : this.defaultStartDate,
                endDate: props.initFilters.endDate ? getCorrectDefaultDateFormat(props.initFilters.endDate) : this.defaultStartDate,
                startSettDate: props.initFilters.startSettDate ? getCorrectDefaultDateFormat(props.initFilters.startSettDate) : null,
                endSettDate: props.initFilters.endSettDate ? getCorrectDefaultDateFormat(props.initFilters.endSettDate) : null,
                startHour: this.defaultStartDate,
                endHour: this.defaultEndDate,
                minSettDate: null,
                maxSettDate: null
            },
            sort: {
                columns: null,
                order: null
            },
            loadedList: {
                countryList: [],
                companyList: [],
                societyList: [],
                storeList: [],
                activityList: [],
                statusList: [],
                paymentTypeList: [],
                paymentModeList: [],
                cardCategoryList: [],
                cardTypeList: []
            },
            fieldHasErrors: {
                country: false,
                company: false,
                society: false,
                dates: false,
                settDates: false
            }
        };

        this.filterList = (selectedValue, itemList, functionForKey = null) => itemList.map((value) => (
            <MenuItem
                style={{textTransform: 'capitalize'}}
                key={value}
                checked={selectedValue && selectedValue.indexOf(value) > -1}
                value={value}
                primaryText={functionForKey ? functionForKey(value) : value}
                leftIcon={!(selectedValue && selectedValue.indexOf(value) > -1) ? <CheckBoxIcon/> : null}
            />
        ));

        this._promises = [];
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.togglePopover = this.togglePopover.bind(this);
        this.updateCountryList();
        this.updateCompanyList();
        this.updateSocietyList();
        this.updateStoreList();
        this.updateActivityList();
        this.updateStatusList();
        this.updatePaymentModeList();
        this.updatePaymentTypeList();
        this.updateCardCategoryList();
        this.updateCardTypeList();
    }

    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnmount() {
        this._promises.forEach(promise => promise.cancel());
    }

    render() {
        return (
            <div className="transactionPage">
                <Collapsible trigger={T.translate('transactionPage.filters')} open={true}>
                    <div className="transactionFilterContainer">
                        <div className="transactionFilterColContainer">
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.country")} :</label>
                                <SelectField className='transactionFilterFieldDropdown'
                                             value={this.state.filterList.country}
                                             multiple={true}
                                             hintText={T.translate('transactionPage.filter.countryPlaceholder')}
                                             hintStyle={{textTransform: 'initial'}}
                                             errorText={this.state.fieldHasErrors.country && T.translate('userForm.errors.requiredField')}
                                             onChange={(event, key, value) => {
                                                 this.handleFilterChangeCountry('country', value)}}
                                             style={{ backgroundColor: "red!important" }}
                                             dropDownMenuProps={{
                                                 anchorOrigin: {
                                                     vertical: "bottom",
                                                     horizontal: "left"
                                                 },
                                             }}>
                                    <MenuItem
                                        style={{textTransform: 'capitalize'}}
                                        key={"all"}
                                        checked={this.isAllSelected(this.state.filterList.country, this.state.loadedList.countryList)}
                                        value={"all"}
                                        primaryText={T.translate('transactionPage.filter.allMale')}
                                        leftIcon={!(this.isAllSelected(this.state.filterList.country, this.state.loadedList.countryList)) ? <CheckBoxIcon/> : null}
                                    />
                                    {this.filterList(this.state.filterList.country, this.state.loadedList.countryList)}
                                </SelectField>
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.company")} :</label>
                                <SelectField className='transactionFilterFieldDropdown'
                                             value={this.state.filterList.company}
                                             multiple={true}
                                             hintText={T.translate('transactionPage.filter.companyPlaceholder')}
                                             hintStyle={{textTransform: 'initial'}}
                                             errorText={this.state.fieldHasErrors.company && T.translate('userForm.errors.requiredField')}
                                             onChange={(event, key, value) => {
                                                 this.handleFilterChangeCompany('company', value)}}
                                             dropDownMenuProps={{
                                                 anchorOrigin: {
                                                     vertical: "bottom",
                                                     horizontal: "left"
                                                 },
                                             }}>
                                    <MenuItem
                                        style={{textTransform: 'capitalize'}}
                                        key={"all"}
                                        checked={this.isAllSelected(this.state.filterList.company, this.state.loadedList.companyList)}
                                        value={"all"}
                                        primaryText={T.translate('transactionPage.filter.allFemale')}
                                        leftIcon={!(this.isAllSelected(this.state.filterList.company, this.state.loadedList.companyList)) ? <CheckBoxIcon/> : null}
                                    />
                                    {this.filterList(this.state.filterList.company, this.state.loadedList.companyList)}
                                </SelectField>
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.society")} :</label>
                                <SelectField className='transactionFilterFieldDropdown'
                                             value={this.state.filterList.society}
                                             multiple={true}
                                             hintText={T.translate('transactionPage.filter.societyPlaceholder')}
                                             hintStyle={{textTransform: 'initial'}}
                                             errorText={this.state.fieldHasErrors.society && T.translate('userForm.errors.requiredField')}
                                             onChange={(event, key, value) => {
                                                 this.handleFilterChangeSociety('society', value)}}
                                             dropDownMenuProps={{
                                                 anchorOrigin: {
                                                     vertical: "bottom",
                                                     horizontal: "left"
                                                 },
                                             }}>
                                    <MenuItem
                                        style={{textTransform: 'capitalize'}}
                                        key={"all"}
                                        checked={this.isAllSelected(this.state.filterList.society, this.state.loadedList.societyList)}
                                        value={"all"}
                                        primaryText={T.translate('transactionPage.filter.allFemale')}
                                        leftIcon={!(this.isAllSelected(this.state.filterList.society, this.state.loadedList.societyList)) ? <CheckBoxIcon/> : null}
                                    />
                                    {this.filterList(this.state.filterList.society, this.state.loadedList.societyList)}
                                </SelectField>
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.store")} :</label>
                                <SelectField className='transactionFilterFieldDropdown'
                                             value={this.state.filterList.store}
                                             multiple={true}
                                             hintText={T.translate('transactionPage.filter.allMale')}
                                             onChange={(event, key, value) => {
                                                 this.handleFilterChange('store', value, this.state.loadedList.storeList)}}
                                             dropDownMenuProps={{
                                                 anchorOrigin: {
                                                     vertical: "bottom",
                                                     horizontal: "left"
                                                 },
                                             }}>
                                    <MenuItem
                                        style={{textTransform: 'capitalize'}}
                                        key={"all"}
                                        checked={this.isAllSelected(this.state.filterList.store, this.state.loadedList.storeList)}
                                        value={"all"}
                                        primaryText={T.translate('transactionPage.filter.allMale')}
                                        leftIcon={!(this.isAllSelected(this.state.filterList.store, this.state.loadedList.storeList)) ? <CheckBoxIcon/> : null}
                                    />
                                    {this.filterList(this.state.filterList.store, this.state.loadedList.storeList)}
                                </SelectField>
                            </div>
                        </div>

                        <div className="transactionFilterColContainer">
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.activity")} :</label>
                                <SelectField className='transactionFilterFieldDropdown'
                                             multiple={true}
                                             value={this.state.filterList.activity}
                                             hintText={T.translate('transactionPage.filter.allFemale')}
                                             onChange={(event, key, value) => this.handleFilterChange('activity', value, this.state.loadedList.activityList)}
                                             dropDownMenuProps={{
                                                 anchorOrigin: {
                                                     vertical: "bottom",
                                                     horizontal: "left"
                                                 },
                                             }}>
                                    <MenuItem
                                        style={{textTransform: 'capitalize'}}
                                        key={"all"}
                                        checked={this.isAllSelected(this.state.filterList.activity, this.state.loadedList.activityList)}
                                        value={"all"}
                                        primaryText={T.translate('transactionPage.filter.allFemale')}
                                        leftIcon={!(this.isAllSelected(this.state.filterList.activity, this.state.loadedList.activityList)) ? <CheckBoxIcon/> : null}
                                    />
                                    {this.filterList(this.state.filterList.activity, this.state.loadedList.activityList, this.getActivityFromId.bind(this))}
                                </SelectField>
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.idTransaction")} :</label>
                                <MaterialFormInput
                                    hintText={T.translate('transactionPage.filter.allFemale')}
                                    id="idTransaction"
                                    className="searchInput"
                                    value={this.state.filterList.idTransaction}
                                    onChange={(event, value) => this.handleFilterChange('idTransaction', value)}
                                />
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.idOrder")} :</label>
                                <MaterialFormInput
                                    hintText={T.translate('transactionPage.filter.allFemale')}
                                    id="idOrder"
                                    className="searchInput"
                                    value={this.state.filterList.idOrder}
                                    onChange={(event, value) => this.handleFilterChange('idOrder', value)}
                                />
                            </div>
                            {this.props.type === 'ACC' ?
                                <div className="transactionFilterFieldContainer">
                                    <label>{T.translate("transactionPage.filter.status")} :</label>
                                    <SelectField className='transactionFilterFieldDropdown'
                                                 multiple={true}
                                                 value={this.state.filterList.status}
                                                 hintText={T.translate('transactionPage.filter.allMale')}
                                                 onChange={(event, key, value) => this.handleFilterChange('status', value, this.state.loadedList.statusList)}
                                                 dropDownMenuProps={{
                                                     anchorOrigin: {
                                                         vertical: "bottom",
                                                         horizontal: "left"
                                                     },
                                                 }}>
                                        <MenuItem
                                            style={{textTransform: 'capitalize'}}
                                            key={"all"}
                                            checked={this.isAllSelected(this.state.filterList.status, this.state.loadedList.statusList)}
                                            value={"all"}
                                            primaryText={T.translate('transactionPage.filter.allMale')}
                                            leftIcon={!(this.isAllSelected(this.state.filterList.status, this.state.loadedList.statusList)) ? <CheckBoxIcon/> : null}
                                        />
                                        {this.filterList(this.state.filterList.status, this.state.loadedList.statusList)}
                                    </SelectField>
                                </div> : null }
                        </div>

                        <div className="transactionFilterColContainer">
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.paymentType")} :</label>
                                <SelectField className='transactionFilterFieldDropdown'
                                             multiple={true}
                                             value={this.state.filterList.paymentType}
                                             hintText={T.translate('transactionPage.filter.allMale')}
                                             onChange={(event, key, value) => this.handleFilterChange('paymentType', value, this.state.loadedList.paymentTypeList)}
                                             dropDownMenuProps={{
                                                 anchorOrigin: {
                                                     vertical: "bottom",
                                                     horizontal: "left"
                                                 },
                                             }}>
                                    <MenuItem
                                        style={{textTransform: 'capitalize'}}
                                        key={"all"}
                                        checked={this.isAllSelected(this.state.filterList.paymentType, this.state.loadedList.paymentTypeList)}
                                        value={"all"}
                                        primaryText={T.translate('transactionPage.filter.allMale')}
                                        leftIcon={!(this.isAllSelected(this.state.filterList.paymentType, this.state.loadedList.paymentTypeList)) ? <CheckBoxIcon/> : null}
                                    />
                                    {this.filterList(this.state.filterList.paymentType, this.state.loadedList.paymentTypeList.sort((a, b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : -1))}
                                </SelectField>
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.cardCategory")} :</label>
                                <SelectField className='transactionFilterFieldDropdown'
                                             multiple={true}
                                             value={this.state.filterList.cardCategory}
                                             hintText={T.translate('transactionPage.filter.allFemale')}
                                             onChange={(event, key, value) => this.handleFilterChange('cardCategory', value, this.state.loadedList.cardCategoryList)}
                                             dropDownMenuProps={{
                                                 anchorOrigin: {
                                                     vertical: "bottom",
                                                     horizontal: "left"
                                                 },
                                             }}>
                                    <MenuItem
                                        style={{textTransform: 'capitalize'}}
                                        key={"all"}
                                        checked={this.isAllSelected(this.state.filterList.cardCategory, this.state.loadedList.cardCategoryList)}
                                        value={"all"}
                                        primaryText={T.translate('transactionPage.filter.allFemale')}
                                        leftIcon={!(this.isAllSelected(this.state.filterList.cardCategory, this.state.loadedList.cardCategoryList)) ? <CheckBoxIcon/> : null}
                                    />
                                    {this.filterList(this.state.filterList.cardCategory, this.state.loadedList.cardCategoryList.sort((a, b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : -1))}
                                </SelectField>
                            </div>
                        </div>

                        <div className="transactionFilterColContainer">
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.startDate")} :</label>
                                <div className="datepickerContainer">
                                    <DatePicker
                                        className="datePicker"
                                        value={this.state.filterList.startDate}
                                        hintText={T.translate('transactionPage.filter.date')}
                                        onChange={(event, value) => {
                                            this.props.setStartDateAction(getFormattedDate(value))
                                            this.handleFilterChange('startDate', value)
                                        }}
                                            />
                                    <TimePicker
                                        className="timePicker"
                                        hintText={T.translate('transactionPage.filter.hour')}
                                        value={this.state.filterList.startHour}
                                        format="24hr"
                                        onChange={(event, value) => this.handleFilterChange('startHour', value)}
                                    />
                                    <FontIcon className="material-icons" color="inherit">date_range</FontIcon>
                                </div>
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.endDate")} :</label>
                                <div className="datepickerContainer">
                                    <DatePicker
                                        value={this.state.filterList.endDate}
                                        className="datePicker"
                                        hintText={T.translate('transactionPage.filter.date')}
                                        onChange={(event, value) => {
                                            this.props.setEndDateAction(getFormattedDate(value))
                                            this.handleFilterChange('endDate', value)
                                        }}
                                    />
                                    <TimePicker
                                        className="timePicker"
                                        hintText={T.translate('transactionPage.filter.hour')}
                                        value={this.state.filterList.endHour}
                                        format="24hr"
                                        onChange={(event, value) => this.handleFilterChange('endHour', value)}
                                    />
                                    <FontIcon className="material-icons" color="inherit">date_range</FontIcon>
                                </div>
                            </div>
                            <div className="error-text">{this.state.fieldHasErrors.dates? T.translate('common.invalidDate'):''}</div>

                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.startSettDate")} :</label>
                                <div className="datepickerContainer">
                                    <DatePicker
                                        className="datePicker"
                                        value={this.state.filterList.startSettDate}
                                        minDate={this.state.filterList.minSettDate}
                                        maxDate={this.state.filterList.maxSettDate}
                                        hintText={T.translate('transactionPage.filter.date')}
                                        onChange={(event, value) => {
                                            this.props.setStartSettDateAction(getFormattedDate(value))
                                            this.handleFilterChange('startSettDate', value)
                                        }}
                                    />
                                    <FontIcon className="material-icons" color="inherit">date_range</FontIcon>
                                </div>
                            </div>
                            <div className="transactionFilterFieldContainer">
                                <label>{T.translate("transactionPage.filter.endSettDate")} :</label>
                                <div className="datepickerContainer">
                                    <DatePicker
                                        value={this.state.filterList.endSettDate}
                                        minDate={this.state.filterList.minSettDate}
                                        maxDate={this.state.filterList.maxSettDate}
                                        className="datePicker"
                                        hintText={T.translate('transactionPage.filter.date')}
                                        onChange={(event, value) => {
                                            this.props.setEndSettDateAction(getFormattedDate(value))
                                            this.handleFilterChange('endSettDate', value)
                                        }}
                                    />
                                    <FontIcon className="material-icons" color="inherit">date_range</FontIcon>
                                </div>
                            </div>
                            <div className="error-text">{this.state.fieldHasErrors.settDates? T.translate('common.invalidDate'):''}</div>
                        </div>
                    </div>
                </Collapsible>

                <h3 className="pageTransactionTitle">
                    <div>
                        {T.translate('transactionPage.title'+this.props.type)}
                        <IconButton onClick={this.togglePopover}>
                            <FontIcon className="material-icons">info</FontIcon>
                        </IconButton>
                        <Popover
                            open={this.state.popoverOpen}
                            onRequestClose={() => this.togglePopover()}
                            anchorEl={this.state.anchorEl}
                        >
                            <Card className="InfoCard">
                                <CardTitle className="CardTitle">
                                    {T.translate('transactionPage.info.title' + this.props.type)}
                                </CardTitle>
                                <hr />
                                <CardText className="CardText">
                                    {T.translate('transactionPage.info.description' + this.props.type)}
                                </CardText>
                            </Card>
                        </Popover>
                    </div>
                    <div className={"transactionContainerButtons"}>
                        <RaisedButton className="buttonAction" label={T.translate("transactionPage.filter.search")}
                            secondary onClick={() => {
                                this.handleSearch()
                            }}>
                        </RaisedButton>
                        <RaisedButton className="buttonAction secondary-button" label={T.translate("transactionPage.filter.reset")} secondary
                            onClick={() => {
                                this.handleResetFilter()
                            }}>
                        </RaisedButton>
                    </div>
                </h3>


                <Loader loaded={!this.state.isLoading} color={ColorEnum.GREEN}>
                    <div className="homePageContent">

                        {this.state.transactionList.length !== 0 ?
                            <div className="transactionPageContent">
                                <div className="tableOperation">
                                    <Table className="tableStripped"
                                        fixedHeader={true}
                                        fixedFooter={true}>
                                        {this.getTableHeader()}
                                        <TableBody
                                            displayRowCheckbox={false}
                                            stripedRows={true}>
                                            {this.renderData()}
                                        </TableBody>
                                    </Table>
                                </div>
                                <div className="transaction-footer">
                                    <div className="pagination">
                                        <Pagination total={parseInt(this.state.totalRowNumber, 10)}
                                            rowsPerPage={[10, 20, 50]}
                                            page={parseInt(this.state.page, 10)}
                                            numberOfRows={parseInt(this.state.numberOfRowsPerPage, 10)}
                                            updateRows={(state) => {
                                                this.updatePagination(state.page, state.numberOfRows);
                                            }} />
                                    </div>
                                    <div className="transaction-export">
                                        <RaisedButton className="footerButton" label="PDF" secondary
                                            disabled={this.state.exportLoading} onClick={() => {
                                                this.downloadPDF()
                                            }} />
                                        <RaisedButton className="footerButton" label="CSV" secondary
                                            disabled={this.state.exportLoading} onClick={() => {
                                                this.downloadCsv()
                                            }} />
                                    </div>
                                </div>
                            </div>
                            : this.renderWarningMessage()
                        }
                    </div>
                </Loader>
                <ModalTransaction
                    transaction={this.state.selectedTransaction}
                    open={this.state.detailModalOpen}
                    closeModal={this.closeModal}
                />
            </div>
        );
    }

    togglePopover(event) {
        this.setState({
            popoverOpen: !this.state.popoverOpen,
            anchorEl: event ? event.currentTarget : this.state.anchorEl
        });
    }

    createHeaderItems() {
        this.headerList = [{
            name: "TRAN_NUMB",
            text: T.translate("tableFields.TRAN_NUMB"),
        }, {
            name: "ORDE_NUMB",
            text: T.translate("tableFields.ORDE_NUMB"),
        }, {
            name: "STOR_NAME",
            text: T.translate("tableFields.STOR_NAME"),
        }, {
            name: "CHAN_ID",
            text: T.translate("tableFields.CHAN_ID"),
        }, {
            name: "DATE",
            text: T.translate("tableFields.DATE"),
        }, {
            name: "SETT_DATE",
            text: T.translate("tableFields.SETT_DATE"),
            class: ' alignRight',
            alignRight: true
        }, {
            name: "AMOU",
            text: T.translate("tableFields.AMOU"),
            class: ' alignRight',
            alignRight: true
        }, {
            name: "PAYM_TYPE",
            text: T.translate("tableFields.PAYM_TYPE"),
            class: ' alignRight',
            alignRight: true
        }, {
            name: "PINP_APPL_TYPE",
            text: T.translate("tableFields.PINP_APPL_TYPE"),
            class: ' alignRight',
            alignRight: true
        }, {
            name: "TRAN_TYPE",
            text: T.translate("tableFields.TRAN_TYPE"),
            class: ' alignRight',
            alignRight: true
        }];
        if (this.props.type === 'ACC') {
            this.headerList.push({
                name: "STATUS_ECOM",
                text: T.translate("tableFields.STATUS_ECOM"),
                class: ' alignCenter'
            });
        }
        this.headerList.push({
            class: 'picto-column'
        });
    }

    getTableHeader() {
        return (
            <TableHeader className="headerTableStripped" displaySelectAll={false} adjustForCheckbox={false}>
                {this.getTotalHeader()}
                    <TableRow className="headerFieldRow">
                        {this.headerList.map((item, index) => {
                            if (!!item && item.name) {
                                return (
                                    <TableHeaderColumn key={item.name} className={`transaction-header ${item.class}`}>
                                        <SortComponent isSelected={this.state.sort && this.state.sort.columns === item.name} action={(desc) => {
                                            this.setState({
                                                sort: {
                                                    columns: item.name,
                                                    order: desc ? 'desc' : 'asc'
                                                },
                                            }, this.getTransactionList);
                                        }} text={item.text} alignRight={item.alignRight}/>
                                    </TableHeaderColumn>
                                )
                            } else {
                                return (
                                    <TableHeaderColumn key={index} className={`transaction-header ${item.class}`}>
                                    </TableHeaderColumn>
                                )
                            }
                        })
                        }
                    </TableRow>
            </TableHeader>
        )
    }

    getTotalHeader() {
        return (
            <TableRow key={'footer-common'} className="important">
                <TableRowColumn>
                    {T.translate('table.total')}
                </TableRowColumn>
                <TableRowColumn/>
                <TableRowColumn/>
                <TableRowColumn/>
                <TableRowColumn/>
                <TableRowColumn/>
                <TableRowColumn
                    className="footer-text alignRight">{this.state.amountTotal.toPrice() + T.translate('currency.' + this.state.transactionList[0]["CURR"])}</TableRowColumn>
                <TableRowColumn/>
                <TableRowColumn/>
                <TableRowColumn/>
                {this.props.type === 'ACC' ? <TableRowColumn/> : null}
                <TableRowColumn className="picto-column" />
            </TableRow>
        );
    }

    renderData() {
        return this.state.transactionList.map((data, index) => {
            return <TableRow key={index} className="tableRow">
                {this.headerList.map((header, colIndex) => {
                    return header.name && <TableRowColumn key={colIndex} className={header.class + ' tableRowColumn'}>
                        {header.name === "AMOU" ? data[header.name].toPrice() + T.translate('currency.' + data["CURR"])
                            : header.name === "CHAN_ID" ? this.getActivityFromId(data[header.name]) || T.translate('tableFields.missingData')
                                : header.name === "TRAN_TYPE" ? this.getPaymentTypeFromTransaction(data) || T.translate('tableFields.missingData')
                                        : header.name === "DATE" ?
                                            <span style={{ display: 'block' }}>
                                                {`${data["DATE"]} ${data["HOUR"]}`}
                                            </span>
                                            : data[header.name] || T.translate('tableFields.missingData')
                        }
                    </TableRowColumn>
                })}
                <TableRowColumn key="eye" className="picto-column">
                    <FontIcon className="material-icons" color="inherit" onClick={this.handleTransactionSelection.bind(this, index)}>visibility</FontIcon>
                </TableRowColumn>
            </TableRow>
        })
    }

    renderWarningMessage() {
        let message;
        if (this.state.transactionList.length === 0 && this.state.filterList.country !== null) {
            message = T.translate('transactionPage.listEmpty');
        } else {
            message = T.translate('transactionPage.selectFilter');
        }
        return (
            <div className="warningMessage">
                {message}
            </div>
        )
    }

    /**********************************************************
     ************************ Filtre *************************
     **********************************************************/

    isAllSelected(values, list) {
        return values && list.every(arr => values.includes(arr));
    }

    handleFilterChangeCountry(filterKey, filterValue) {
        this.handleFilterChange(filterKey, filterValue, this.state.loadedList.countryList);
        this.updateCompanyList();
    }

    handleFilterChangeCompany(filterKey, filterValue) {
        this.handleFilterChange(filterKey, filterValue, this.state.loadedList.companyList);
        this.updateSocietyList();
    }

    handleFilterChangeSociety(filterKey, filterValue) {
        this.handleFilterChange(filterKey, filterValue, this.state.loadedList.societyList);
        this.updateStoreList();
    }

    handleFilterChange(filterKey, filterValue, allOptions) {
        let filterList = this.state.filterList;
        if (allOptions && Array.isArray(filterValue) && filterValue.includes("all")) {
            if (allOptions.every(arr => filterValue.includes(arr))) {
                filterList[filterKey] = [];
            } else {
                filterList[filterKey] = allOptions;
            }
        } else {
            filterList[filterKey] = filterValue;
        }
        switch (filterKey) {
            case 'country':
                this.props.setFilterLocation(filterList[filterKey]);
                break;
            case 'company':
                this.props.setFilterClient(filterList[filterKey]);
                break;
            case 'society':
                this.props.setFilterBU(filterList[filterKey]);
                break;
            case 'store':
                if ((filterList.society.length === 0 || filterList.company.length === 0) && filterList[filterKey].length === 1) {
                    TransactionService.getTransactionAssociatedSocietyList(filterList.country, filterList.store)
                        .then((societyList) => {
                            filterList.society = societyList;
                            this.props.setFilterBU(societyList);
                            this.updateStoreList();
                        });
                    TransactionService.getTransactionAssociatedCompanyList(filterList.country, filterList.store)
                        .then((companyList) => {
                            filterList.company = companyList;
                            this.props.setFilterClient(companyList);
                            this.updateSocietyList();
                        });
                    if (filterList.country.length === 0) {
                        TransactionService.getTransactionAssociatedCountryList(filterList.store)
                            .then((countryList) => {
                                filterList.country = countryList;
                                this.props.setFilterLocation(countryList);
                                this.updateCompanyList();
                            });
                    }
                }
                this.props.setFilterShop(filterList[filterKey]);
                break;
            default:
                break;
        }
        this.setState({
            filterList
        }, function() {
            //Mise à jour des erreurs sur les dates
            this.setState({
                fieldHasErrors: {
                    country: this.state.fieldHasErrors.country,
                    company: this.state.fieldHasErrors.company,
                    society: this.state.fieldHasErrors.society,
                    dates: this.validateDateTimeFilters(this.state.filterList.startDate, this.state.filterList.endDate),
                    settDates: this.validateDateTimeFilters(this.state.filterList.startSettDate, this.state.filterList.endSettDate)
                }
            });

            if (filterKey === 'startDate' || filterKey === 'endDate') {
                this.getMinMaxSettDates();
            }
        });
    }

    handleResetFilter() {
        this.props.setFilterLocation(null)
        this.props.setFilterClient(null)
        this.props.setFilterBU(null)
        this.props.setFilterShop(null)
        this.setState({
            page: 1,
            isLoading: true,
            filterList: {
                country: null,
                company: null,
                society: null,
                store: null,
                activity: null,
                idTransaction: '',
                idOrder: '',
                paymentMode: null,
                paymentType: null,
                cardCategory: null,
                cardType: null,
                startDate: this.defaultStartDate,
                endDate: this.defaultEndDate,
                startHour: this.defaultStartDate,
                endHour: this.defaultEndDate,
                startSettDate: this.defaultStartDate,
                endSettDate: this.defaultEndDate,
                minSettDate: null,
                minEndDate: null
            },
            fieldHasErrors: {
                country: false,
                company: false,
                society: false,
                dates: false
            },
        }, this.getTransactionList);
    }
    /**
     *
     * @returns {boolean} if dates has error or not
     */
    validateDateTimeFilters(startDate, endDate){
        let invalidDates;
        if (!startDate || !endDate || startDate < endDate) {
            invalidDates = false
        } else if(startDate.getTime() > endDate.getTime()) {
            invalidDates = true
        }
        return invalidDates
    }

    /**
     *
     * @returns {boolean} if has error or not
     */
    handleFieldsError() {
        const hasNotCountry = this.filterIsEmpty(this.state.filterList.country);
        const hasNotCompany = this.filterIsEmpty(this.state.filterList.company);
        const hasNotSociety = this.filterIsEmpty(this.state.filterList.society);
        const invalidDates = this.validateDateTimeFilters(this.state.filterList.startDate, this.state.filterList.endDate);
        const invalidSettDates = this.validateDateTimeFilters(this.state.filterList.startSettDate, this.state.filterList.endSettDate);
        this.setState({
            fieldHasErrors: {
                country: hasNotCountry,
                company: hasNotCompany,
                society: hasNotSociety,
                dates: invalidDates,
                settDates: invalidSettDates
            }
        });
        return hasNotCountry || hasNotCompany || hasNotSociety || invalidDates;
    }

    filterIsEmpty(value) {
        if (value === null) {
            return true
        }

        if (Array.isArray(value) && value.length === 0) {
            return true
        }

        return false
    }

    handleSearch() {
        if (this.handleFieldsError()) {
            return;
        }
        this.setState({
            page: 1,
            isLoading: true
        }, this.getTransactionList);
    }

    handleTransactionSelection(index) {
        this.setState({
            selectedTransaction: this.state.transactionList[index],
            detailModalOpen: true
        });
    }

    updatePagination(page, numberOfRowsPerPage) {
        this.setState({
            page,
            numberOfRowsPerPage,
            selectedTransaction: null,
            isLoading: true
        }, () => this.getTransactionList());
    }


    /**********************************************************
     ************************ Utils ***************************
     **********************************************************/

    concatDateAndHourFromDates(date, time) {
        if (date === undefined || date === null) {
            return null;
        }
        if (time === undefined || time === null) {
            return new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                0,
                0,
                0,
            );
        }
        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            time.getHours(),
            time.getMinutes(),
            0,
        );
    }

    /**********************************************************
     * **************** Exports *******************************
     **********************************************************/

    downloadPDF() {
        this.setState({
            exportLoading: true,
        });
        this.getExport("pdf");
    }

    downloadCsv() {
        this.setState({
            exportLoading: true,
        });
        this.getExport("csv");
    }

    getActivityFromId(activityId) {
        let activities = []
        if (activityId) {
            if (Array.isArray(activityId)) {
                if (activityId.includes(inStoreId)) {
                    activities = [...activities, inStore];
                } else if (activityId.includes(eCommerceId)) {
                    activities = [...activities, eCommerce];
                } else {
                    activities = [...activities, activityId];
                }
            } else {
                if (activityId === inStoreId) {
                    return inStore;
                } else if (activityId === eCommerceId) {
                    return eCommerce;
                }
                return activityId;
            }
        }

        return activities;
    };

    getPaymentTypeFromTransaction(transaction) {
        return transaction["TRAN_TYPE"] ? transaction["TRAN_TYPE"] : transaction["TYPE_TRANS_ECOM"];
    }

    getStoreDisplayFromTransaction(transaction) {
        return transaction["STOR_CODE"] + " - " + transaction["STOR_NAME"];
    }

    closeModal = () => {
        this.setState({
            detailModalOpen: false
        });
    };


    /**********************************************************
     * **************** Appels Web Service ********************
     **********************************************************/

    updatePaymentModeList = () => {
        const getPaymentModePromise = TransactionService.getTransactionPaymentModeList();
        this.updateList(getPaymentModePromise, "paymentMode");
    };

    updatePaymentTypeList = () => {
        const getPaymentTypePromise = TransactionService.getTransactionPaymentTypeList();
        this.updateList(getPaymentTypePromise, "paymentType");
    };

    updateCardCategoryList = () => {
        const getCardCategoryPromise = TransactionService.getTransactionCardCategoryList();
        this.updateList(getCardCategoryPromise, "cardCategory");
    };

    updateCardTypeList = () => {
        const getCardTypePromise = TransactionService.getTransactionCardTypeList();
        this.updateList(getCardTypePromise, "cardType");
    };

    updateStatusList = () => {
        const getStatusPromise = TransactionService.getTransactionStatusList();
        this.updateList(getStatusPromise, "status");
    };

    updateActivityList = () => {
        const getActivityPromise = TransactionService.getTransactionActivityList();
        this.updateList(getActivityPromise, "activity");
    };

    updateCountryList = () => {
        const getCountryPromise = TransactionService.getTransactionCountryList();
        this.updateList(getCountryPromise, "country");
    };

    updateCompanyList = () => {
        const getCompanyPromise = TransactionService.getTransactionCompanyList(
            this.state.filterList.country
        );
        this.updateList(getCompanyPromise, "company");
    };

    updateSocietyList = () => {
        const getSocietyPromise = TransactionService.getTransactionSocietyList(
            this.state.filterList.country,
            this.state.filterList.company,
        );
        this.updateList(getSocietyPromise, "society");
    };

    updateStoreList = () => {
        const getStorePromise = TransactionService.getTransactionStoreList(
            this.state.filterList.country,
            this.state.filterList.company,
            this.isAllSelected(this.state.filterList.society, this.state.loadedList.societyList) ? null : this.state.filterList.society,
        );
        this.updateList(getStorePromise, "store");
    };

    updateList(promise, keyList) {
        const cancelablePromise = makeCancelable(promise);
        this._promises.push(cancelablePromise);

        let loadedListTmp = this.state.loadedList;
        let filterListTmp = this.state.filterList;
        cancelablePromise
            .promise
            .then(res => {
                loadedListTmp[keyList + "List"] = res;
                if (filterListTmp[keyList] && loadedListTmp[keyList + "List"]) {
                    filterListTmp[keyList] = filterListTmp[keyList].filter(value => loadedListTmp[keyList + "List"].toString().indexOf(value) !== -1);
                    switch (keyList) {
                        case 'country':
                            this.props.setFilterLocation(filterListTmp[keyList]);
                            break;
                        case 'company':
                            this.props.setFilterClient(filterListTmp[keyList]);
                            break;
                        case 'society':
                            this.props.setFilterBU(filterListTmp[keyList]);
                            break;
                        case 'store':
                            this.props.setFilterShop(filterListTmp[keyList]);
                            break;
                        default:
                            break;
                    }
                }

                if (res.length === 1) {
                    this.handleFilterChange(keyList, [res[0]]);
                }
                this.setState({
                    loadedList: loadedListTmp,
                    filterList: filterListTmp
                })
                if (keyList === 'country') {
                    this.updateCompanyList();
                }
                if (keyList === 'company') {
                    this.updateSocietyList();
                }
                if (keyList === 'society') {
                    this.updateStoreList();
                }
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({
                        error
                    });
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    }

    getTransactionList = () => {
        const getTransactionPromise = TransactionService.getTransactionList(
            this.state.page,
            this.state.numberOfRowsPerPage,
            this.state.sort,
            this.state.filterList.country,
            this.isAllSelected(this.state.filterList.company, this.state.loadedList.companyList) ? null : this.state.filterList.company,
            this.isAllSelected(this.state.filterList.society, this.state.loadedList.societyList) ? null : this.state.filterList.society,
            this.isAllSelected(this.state.filterList.store, this.state.loadedList.storeList) ? null : this.state.filterList.store,
            this.isAllSelected(this.state.filterList.activity, this.state.loadedList.activityList) ? null : this.state.filterList.activity,
            this.isAllSelected(this.state.filterList.status, this.state.loadedList.statusList) ? null : this.state.filterList.status,
            this.state.filterList.idTransaction,
            this.state.filterList.idOrder,
            this.isAllSelected(this.state.filterList.paymentMode, this.state.loadedList.paymentModeList) ? null : this.state.filterList.paymentMode,
            this.isAllSelected(this.state.filterList.paymentType, this.state.loadedList.paymentTypeList) ? null : this.state.filterList.paymentType,
            this.isAllSelected(this.state.filterList.cardCategory, this.state.loadedList.cardCategoryList) ? null : this.state.filterList.cardCategory,
            this.isAllSelected(this.state.filterList.cardType, this.state.loadedList.cardTypeList) ? null : this.state.filterList.cardType,
            this.concatDateAndHourFromDates(this.state.filterList.startDate, this.state.filterList.startHour),
            this.concatDateAndHourFromDates(this.state.filterList.endDate, this.state.filterList.endHour),
            this.state.filterList.startSettDate,
            this.state.filterList.endSettDate,
            this.props.type
        );

        const cancelablePromise = makeCancelable(getTransactionPromise);
        this._promises.forEach(promise => promise.cancel());
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then(res => {
                const page = res.transactionPage;
                this.setState({
                    transactionList: page.resourceList,
                    totalRowNumber: page.total,
                    amountTotal: res.amountTotal,
                    isLoading: false
                })

            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({
                        error,
                        isLoading: false
                    });
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    };

    getExport = (format) => {
        TransactionService.getExport(
            1,
            this.state.totalRowNumber,
            this.state.sort,
            this.state.filterList.country,
            this.isAllSelected(this.state.filterList.company, this.state.loadedList.companyList) ? null : this.state.filterList.company,
            this.isAllSelected(this.state.filterList.society, this.state.loadedList.societyList) ? null : this.state.filterList.society,
            this.isAllSelected(this.state.filterList.store, this.state.loadedList.storeList) ? null : this.state.filterList.store,
            this.isAllSelected(this.state.filterList.activity, this.state.loadedList.activityList) ? null : this.state.filterList.activity,
            this.isAllSelected(this.state.filterList.status, this.state.loadedList.statusList) ? null : this.state.filterList.status,
            this.state.filterList.idTransaction,
            this.state.filterList.idOrder,
            this.isAllSelected(this.state.filterList.paymentMode, this.state.loadedList.paymentModeList) ? null : this.state.filterList.paymentMode,
            this.isAllSelected(this.state.filterList.paymentType, this.state.loadedList.paymentTypeList) ? null : this.state.filterList.paymentType,
            this.isAllSelected(this.state.filterList.cardCategory, this.state.loadedList.cardCategoryList) ? null : this.state.filterList.cardCategory,
            this.isAllSelected(this.state.filterList.cardType, this.state.loadedList.cardTypeList) ? null : this.state.filterList.cardType,
            this.concatDateAndHourFromDates(this.state.filterList.startDate, this.state.filterList.startHour),
            this.concatDateAndHourFromDates(this.state.filterList.endDate, this.state.filterList.endHour),
            this.state.filterList.startSettDate,
            this.state.filterList.endSettDate,
            this.props.type,
            format,
            this.setLoaded.bind(this)
        );
    };

    getMinMaxSettDates = () => {
        const getMinMaxSettDatesPromise = TransactionService.getMinMaxSettDate(
            this.state.filterList.country,
            this.isAllSelected(this.state.filterList.company, this.state.loadedList.companyList) ? null : this.state.filterList.company,
            this.isAllSelected(this.state.filterList.society, this.state.loadedList.societyList) ? null : this.state.filterList.society,
            this.isAllSelected(this.state.filterList.store, this.state.loadedList.storeList) ? null : this.state.filterList.store,
            this.isAllSelected(this.state.filterList.activity, this.state.loadedList.activityList) ? null : this.state.filterList.activity,
            this.isAllSelected(this.state.filterList.status, this.state.loadedList.statusList) ? null : this.state.filterList.status,
            this.state.filterList.idTransaction,
            this.state.filterList.idOrder,
            this.isAllSelected(this.state.filterList.paymentMode, this.state.loadedList.paymentModeList) ? null : this.state.filterList.paymentMode,
            this.isAllSelected(this.state.filterList.paymentType, this.state.loadedList.paymentTypeList) ? null : this.state.filterList.paymentType,
            this.isAllSelected(this.state.filterList.cardCategory, this.state.loadedList.cardCategoryList) ? null : this.state.filterList.cardCategory,
            this.isAllSelected(this.state.filterList.cardType, this.state.loadedList.cardTypeList) ? null : this.state.filterList.cardType,
            this.concatDateAndHourFromDates(this.state.filterList.startDate, this.state.filterList.startHour),
            this.concatDateAndHourFromDates(this.state.filterList.endDate, this.state.filterList.endHour),
            this.props.type,
        );

        const cancelablePromise = makeCancelable(getMinMaxSettDatesPromise);
        this._promises.forEach(promise => promise.cancel());
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then(res => {
                const minDate = res[0] ? new Date(res[0]) : null;
                const maxDate = res[1] ? new Date(res[1]) : null;

                let startSettDate = this.state.filterList.startSettDate
                let endSettDate = this.state.filterList.endSettDate
                if (minDate) {
                    if (startSettDate && startSettDate < minDate) {
                        startSettDate = null;
                    }
                    if (endSettDate && endSettDate < minDate) {
                        endSettDate = null;
                    }
                } else {
                    startSettDate = null;
                    endSettDate = null;
                }
                if (maxDate) {
                    if (startSettDate && startSettDate > maxDate) {
                        startSettDate = null;
                    }
                    if (endSettDate && endSettDate > maxDate) {
                        endSettDate = null;
                    }
                }
                this.setState({
                    filterList: {
                        country: this.state.filterList.country,
                        company: this.state.filterList.company,
                        society: this.state.filterList.society,
                        store: this.state.filterList.store,
                        activity: null,
                        idTransaction: null,
                        idOrder: null,
                        paymentMode: null,
                        paymentType: null,
                        cardCategory: null,
                        cardType: null,
                        startDate: this.state.filterList.startDate,
                        endDate: this.state.filterList.endDate,
                        startSettDate: startSettDate,
                        endSettDate:  endSettDate,
                        startHour: this.defaultStartDate,
                        endHour: this.defaultEndDate,
                        minSettDate: minDate,
                        maxSettDate: maxDate,
                    }
                });
                if (startSettDate == null) {
                    this.props.setStartSettDateAction(startSettDate);
                }
                if (endSettDate == null) {
                    this.props.setEndSettDateAction(endSettDate);
                }
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({
                        error,
                        isLoading: false
                    });
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    };

    setLoaded(loaded) {
        this.setState({
            exportLoading: loaded
        });
    }

    /**********************************************************
     * ************** Gestion des promises ******************
     **********************************************************/

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit etre appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled(promise) {
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };

}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionPage);



// WEBPACK FOOTER //
// ./src/ui/transaction/Transaction.js